export enum LayerSector {
  Zoning = "zoning",
  Census = "census",
  Rates = "rates",
  Location = "location",
  Incentives = "incentives",
  Borders = "borders",
  Environmental = "environmental",
}
